import type { Resource } from '../../';
export const forms_error_phoneNumber_invalidCountryCode: Resource = {"default":"The phone number has an invalid country or area code."};
